<template>
  <div>
    <div>
      <h5>{{ $tI_G('Migration period slider title') }}</h5>
    </div>
    <div class="lab-timeline">
      <div class="line-item" 
        v-for="periodItem in periods" :key="periodItem.id"
        :class="{'done': periodItem.number <= selectedPeriodNumber,
                'active': periodItem.id == selectedPeriodId}" >
          <div class="node">
            <span class="timeline-title sub-title">{{ $tI(periodItem.name) }}</span>
            <div class="tvar" @click="onChangePeriod(periodItem)"></div>
          </div>
      </div>
    </div>
  </div>

</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

export default {
  components: {
  },
  props: {
  },
  methods: {
    onChangePeriod(periodItem) {
      this.$store.commit('period/setSelectedPeriod', periodItem);

      let value = '';
      if (periodItem.number === 1) {
        value = 'Iframe.ancientDnaAncientOriginsBreakdownBronzeAgeClicked'
      } else if(periodItem.number === 2) {
        value = 'Iframe.ancientDnaAncientOriginsBreakdownIronAgeClicked'
      } else if(periodItem.number === 3) {
         value = 'Iframe.ancientDnaAncientOriginsBreakdownRomanEraClicked'
      } else if(periodItem.number === 4) {
         value = 'Iframe.ancientDnaAncientOriginsBreakdownMiddleAgesClicked'
      }
      
      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: value,
      });
    },
  },
  computed: {
    selectedPeriodId() {
      return this.$store.state.period.selectedPeriod.id;
    },
    selectedPeriodNumber() {
      return this.$store.state.period.selectedPeriod.number;
    },
    periods() {
      return this.$store.getters['period/getPeriods'];
    },
  },
  mounted() {
    this.$store.dispatch('period/fetchPeriods');
  },
}
</script>

<style lang="scss" scoped>

</style>
